import * as Yup from 'yup';

import { FieldProps } from '~components/form-fields';

// Cultural Safety form for the care plan Cultural Safety tab. A single-save form
// (one record per plan): a required cultural-background textarea, an optional
// trauma-aware notes textarea, and an interpreter-required toggle. Primary
// language and worker preferences are deliberately omitted — they live on the
// client record, not the cultural-safety record.
export const culturalSafetyFields: FieldProps = {
  background_notes: {
    type: 'textarea',
    caption: 'Cultural background and considerations',
    required: true,
    dataCy: 'care-plan-cultural-safety-background',
  },
  trauma_notes: {
    type: 'textarea',
    caption: 'Trauma-aware care notes',
    dataCy: 'care-plan-cultural-safety-trauma',
  },
  is_interpreter_required: {
    type: 'switch',
    caption: 'Interpreter required',
    dataCy: 'care-plan-cultural-safety-interpreter',
  },
};

export const culturalSafetySchema = Yup.object().shape({
  background_notes: Yup.string().trim().required('Cultural background and considerations is required'),
});
